import type { AlloyLegacyThemeDesignTokens, InputDesignTokens } from '../types';
import type { SignatureDesignTokens } from '../types/signature';
import type { WeaveTheme } from '../types/weaveTypes';

type WeaveTokens = NonNullable<WeaveTheme['tokens']>;

export const getSignatureTokensAlloy = (
  theme: AlloyLegacyThemeDesignTokens,
): SignatureDesignTokens => ({
  backgroundColor: theme.tokens.colors.background.secondary.value,
  borderRadius: `${theme.borderRadius.small}px`,
  boxShadowHover: theme.halos.hover,
  boxShadowFocus: theme.halos.focus,
  color: theme.tokens.colors.text.primary.value,
  fontFamily: theme.typography.labelMedium.fontFamily,
  fontWeight: theme.typography.labelMedium.fontWeight,
  fontSize: theme.typography.labelMedium.fontSize,
  lineHeight: theme.typography.labelMedium.lineHeight,
  labelColor: theme.tokens.colors.text.secondary.value,
  labelFontSize: theme.typography.labelSmall.fontSize,
  labelLineHeight: theme.typography.labelSmall.lineHeight,
});

export const getSignatureTokensWeave = (
  tokens: WeaveTokens,
  fontFamily: string,
): SignatureDesignTokens => {
  const input = tokens.component?.input ?? {};
  const semantic = tokens?.semantic;
  return {
    backgroundColor: semantic?.['background-color']?.surface?.[200],
    borderRadius: input['border-top-left-radius'],
    boxShadowHover: input['box-shadow']?.hover,
    boxShadowFocus: input['box-shadow']?.focus,
    color: input['text-color'],
    fontFamily,
    fontWeight: input['font-weight'],
    fontSize: input['font-size'],
    lineHeight: input['line-height'],
    labelColor: semantic?.['text-color']?.light,
    labelFontSize: tokens.generic?.['font-size']?.[12],
    labelLineHeight: tokens.generic?.['line-height']?.[16],
  };
};

export const getSignatureTokensWeave3 = (
  processedInput: InputDesignTokens | undefined,
): SignatureDesignTokens => ({
  backgroundColor: processedInput?.box?.backgroundColor,
  borderRadius: processedInput?.borderTopLeftRadius,
  boxShadowHover: processedInput?.boxShadow?.hover,
  boxShadowFocus: processedInput?.boxShadow?.focus,
  color: processedInput?.color,
  fontFamily: processedInput?.fontFamily,
  fontWeight: processedInput?.fontWeight,
  fontSize: processedInput?.fontSize,
  lineHeight: processedInput?.lineHeight,
  labelColor: undefined,
  labelFontSize: undefined,
  labelLineHeight: undefined,
});
